import React from 'react';
import * as S from './AmenitiesDetailsLoader.styles';

const AmenitiesLoader = () => (
  <S.AmenitiesDetailsLoaderWrapDiv>
    <S.AmenitiesDetailsLoaderHeaderWrapDiv>
      <S.AmenitiesDetailsLoaderInnerHeaderDiv />
    </S.AmenitiesDetailsLoaderHeaderWrapDiv>
    <S.AmenitiesDetailsLoaderListWrapDiv>
      <S.AmenitiesDetailsLoaderListInnerWrapDiv>
        <S.AmenitiesDetailsLoaderIconDiv />
        <S.AmenitiesDetailsLoaderTitleWrapDiv />
      </S.AmenitiesDetailsLoaderListInnerWrapDiv>
      <S.AmenitiesDetailsLoaderListInnerWrapDiv>
        <S.AmenitiesDetailsLoaderIconDiv />
        <S.AmenitiesDetailsLoaderTitleLargeWrapDiv />
      </S.AmenitiesDetailsLoaderListInnerWrapDiv>
      <S.AmenitiesDetailsLoaderListInnerWrapDiv>
        <S.AmenitiesDetailsLoaderIconDiv />
        <S.AmenitiesDetailsLoaderTitleWrapDiv />
      </S.AmenitiesDetailsLoaderListInnerWrapDiv>
      <S.AmenitiesDetailsLoaderListInnerWrapDiv>
        <S.AmenitiesDetailsLoaderIconDiv />
        <S.AmenitiesDetailsLoaderTitleLargeWrapDiv />
      </S.AmenitiesDetailsLoaderListInnerWrapDiv>
    </S.AmenitiesDetailsLoaderListWrapDiv>
  </S.AmenitiesDetailsLoaderWrapDiv>
);

export default AmenitiesLoader;
